import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
import { toast } from 'react-toastify';

function PodcastCreate() {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);

    const create = () => {
        if (loading)
            return;
        var err = [];
        if (name === 0)
            err.push('A podcast name is required.');
        if (err.length === 0) {
            setLoading(true);
            axios.post(process.env.REACT_APP_API_URL + 'podcast/add', {
                name: name,
                description: description
            }).then((r) => {
                if (r?.data?.status == 'Success') {
                    setTimeout(() => {
                        setLoading(false);
                        navigate('/protected/podcast-select');
                    }, 1750);
                    toast.success('Podcast successfully created.');
                    return;
                }
                setLoading(false);
            }).catch(e => setLoading(false));
        } else {
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
        }
    }
    return (
        <div className="container-center">
            <div className="container mw-800 w-100 p-10">
                <div className="form">
                    <div className="w-100 xs-w-100">
                        <label htmlFor="name">Name</label>
                        <input id="name" type="text" className="w-100" onChange={(e) => { setName(e.target.value) }} />
                    </div>
                    <div className="w-100 xs-w-100">
                        <label htmlFor="description">Description</label>
                        <textarea id="description" rows="6" className="w-100" onChange={(e) => { setDescription(e.target.value) }} />
                    </div>
                    <div className="w-50">
                        <button className="btn" onClick={create}>
                            {loading ? (
                                <div className="loading f-row">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            ) : <>Create</>
                            }
                        </button>
                    </div>
                    <div className="w-50">
                        <Link className="btn btn-red" to="/protected/podcast-select">
                            Cancel
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PodcastCreate;